// extracted by mini-css-extract-plugin
module.exports = {"numberFormWrap":"NumberForm_numberFormWrap__1PYQD","numberInputWrap":"NumberForm_numberInputWrap__62QBF","button":"NumberForm_button__2TQJd"};